/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Wrapped_MoreInputs */

const en_us2_progress_extra_wrapped_more = /** @type {(inputs: Progress_Extra_Wrapped_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More retrospectives`)
};

const pt_br2_progress_extra_wrapped_more = /** @type {(inputs: Progress_Extra_Wrapped_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais retrospectivas`)
};

const es_419_progress_extra_wrapped_more = /** @type {(inputs: Progress_Extra_Wrapped_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más resúmenes`)
};

const pt_pt2_progress_extra_wrapped_more = /** @type {(inputs: Progress_Extra_Wrapped_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais retrospetivas`)
};

const fr_fr2_progress_extra_wrapped_more = /** @type {(inputs: Progress_Extra_Wrapped_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de bilans`)
};

const de_de2_progress_extra_wrapped_more = /** @type {(inputs: Progress_Extra_Wrapped_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Rückblicke`)
};

const it_it2_progress_extra_wrapped_more = /** @type {(inputs: Progress_Extra_Wrapped_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altri riepiloghi`)
};

/**
* | output |
* | --- |
* | "More retrospectives" |
*
* @param {Progress_Extra_Wrapped_MoreInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_wrapped_more = /** @type {((inputs?: Progress_Extra_Wrapped_MoreInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Wrapped_MoreInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_wrapped_more(inputs)
	if (locale === "es-419") return es_419_progress_extra_wrapped_more(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_wrapped_more(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_wrapped_more(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_wrapped_more(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_wrapped_more(inputs)
	return en_us2_progress_extra_wrapped_more(inputs)
});
export { progress_extra_wrapped_more as "progress-extra.wrapped_more" }